import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
declare var Yiit;

@Component({
  selector: 'app-multidrop',
  templateUrl: './multidrop.component.html',
  styleUrls: ['./multidrop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultidropComponent implements OnInit {

  public isMultiDrop = false;
  public isVisible = false;
  public Yiit = Yiit;

  constructor(private adapter: CesiumAdapterService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.adapter.isDrawingFigure.subscribe((flag)=>{
      this.isVisible = flag;
      this.cd.markForCheck();
    })
  }

  toggleMultiDrop(){
    this.isMultiDrop = !this.isMultiDrop;
    this.adapter.setMultiDrop(this.isMultiDrop);
  }
}
